import React, { useMemo } from 'react';
import { TorpedoLayoutedItem, TorpedoItem as TorpedoItemType, TorpedoProps } from '../../types';

type Props = Pick<TorpedoProps, 'renderItem'> & {
  layoutItem: TorpedoLayoutedItem<TorpedoItemType>;
  dataItem?: TorpedoItemType;
};

const TorpedoItem: React.FC<Props> = ({ layoutItem, dataItem, renderItem }) => {
  const itemStyle: React.CSSProperties = {
    width: layoutItem.width,
    height: layoutItem.height,
  };

  const wrapStyles: React.CSSProperties = {
    width: layoutItem.width,
    height: '100%',
    display: 'inline-block',
    float: 'left',
    position: 'relative',
    margin: layoutItem.margins,
  };

  const mergedItem: TorpedoLayoutedItem<TorpedoItemType> = useMemo(
    () => ({ ...layoutItem, dto: { ...layoutItem.dto, ...dataItem } }),
    [layoutItem, dataItem]
  );

  // TODO kill the first param of the callback
  return (
    <div style={wrapStyles}>
      {dataItem ? renderItem({}, mergedItem, itemStyle) : <div style={itemStyle} />}
    </div>
  );
};
TorpedoItem.displayName = 'TorpedoItem';

export default TorpedoItem;
